// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductsSelector_wrapper__oF4Rp","dropdownGroupLabel":"ProductsSelector_dropdownGroupLabel__JFDwZ","dropdownItem":"ProductsSelector_dropdownItem__J47SX"};